import { BaseParentControlDrawer } from '../../core/abstraction/BaseParentControlDrawer';
import { GAME_MODES, GAME_SCENE } from '../../core/constats';
import { PreBonusContentMobileDrawer } from './drawers/PreBonusContentMobileDrawer';
import {
  GAME_MODE,
  GAME_SCENE_STATE,
  PRE_BONUS_RESPONSE_ANIMATE,
} from '../../stateManagment/gameState';
import { preBonusResponseHelper } from '../../services/helperService/PreBonusResponseHelper';
import { gameService } from '../../services/GameService';
import { delay } from '../../core/helpers/delay';
import { spinButtonHelper } from '../../services/helperService/SpinButtonHelper';
import { hold } from '../../core/helpers/hold';
import { PreBonusContentDesktopDrawer } from './drawers/PreBonusContentDesktopDrawer';

class PreBonusContentDrawer extends BaseParentControlDrawer {
  constructor(apps) {
    super(apps);
    this.count = 0;
  }

  getAndHandleRequest(holding) {
    gameService.preBonusSpin().then(result => {
      const isNotEmpty = preBonusResponseHelper.isNotEmpty(result.spin);
      holding(() => {
        preBonusResponseHelper.setData(result.spin);
        const subscriber = this.addSubscriber(PRE_BONUS_RESPONSE_ANIMATE.subscribe(e => {
          if (!e.size) {
            preBonusResponseHelper.setReSpin(result.remainingSpinCount);
            if (result.remainingSpinCount > 0) {
              delay(() => {
                this.spin();
              }, 1000);
            }
            delay(() => {
              if (result.remainingSpinCount === 0) {
                GAME_SCENE_STATE.next(GAME_SCENE.BONUS);
              }
              subscriber.unsubscribe();
            }, 500);
          }
        }));
      }, isNotEmpty ? 1000 : 3000);
    }).catch(error => {
      this.count++
      if (this.count <= 10) {
        delay(() => {
          this.getAndHandleRequest(holding);
        }, 500)
      } else {
        this.count = 0;
        preBonusResponseHelper.setError(error || 'Error');
        spinButtonHelper.enable();
      }
    });
  }

  spin() {
    this.count = 0;
    const holding = hold();
    preBonusResponseHelper.resetError();
    spinButtonHelper.disable();
    preBonusResponseHelper.decrementReSpin();
    this.getAndHandleRequest(holding)
    preBonusResponseHelper.resetPreBonusResponseAnimateState();
    this.applications[GAME_MODE.getValue()].loadPreBonusAnimation();
  }

  screenTransaction() {
    this.applications[GAME_MODE.getValue()].screenTransaction();
  }
}

export const preBonusContentDrawer = new PreBonusContentDrawer({
  [GAME_MODES.MOBILE]: new PreBonusContentMobileDrawer(),
  [GAME_MODES.DESKTOP]: new PreBonusContentDesktopDrawer(),
});
